/**
 * @Author: WeiZisen
 * @Date: 2020-12-25 09:06:21
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-10 11:30:02
 * @Description: 全局自定义指令
 * @FilePath: \bim-vue-template\src\directives\index.js
 */
import Vue from 'vue'
/**
 * @description: 防抖 单位时间只触发最后一次
 * @例 <el-button v-debounce="fn">查询</el-button>
 */

Vue.directive('debounce', {
  inserted: function(el, binding) {
    let timer
    el.addEventListener('click', () => {
      timer && clearTimeout(timer)
      timer = setTimeout(() => binding.value(), 200)
    })
  },
})
/**
 * @description: 节流 每单位时间可触发一次  第一次瞬间触发，最后一次不管是否达到间隔时间依然触发
 * @例 <el-button v-throttle="fn">查询</el-button>
 */
Vue.directive('throttle', {
  inserted: function(el, binding) {
    let timer, timer_end
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer_end)
        return (timer_end = setTimeout(() => binding.value(), 2000))
      }
      binding.value()
      timer = setTimeout(() => (timer = null), 2000)
    })
  },
})
